import clsx from "clsx";

export default function Divider({ className = "" }) {
  return <hr className={clsx(className, "border-t-1 my-4 border-gray-400")} />;
}
